<!-- eslint-disable vue/no-mutating-props -->
<template>
  <card class="stacked-form" :title="computedTitle" :on-cancel="cancel">
    <Form ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(saveMachine)">
        <div class="row">
          <div class="col-md-6">
            <material-input-field
              id="nameInput"
              ref="nameInput"
              v-model="name"
              :name="'name'"
              variant="static"
              :label="$t('common.name') + ' *'"
              :placeholder="$t('common.name')"
            />
            <material-input-field
              id="licencePlateInput"
              ref="licencePlateInput"
              v-model="licencePlate"
              :name="'licencePlate'"
              variant="static"
              :label="$t('heavyMachines.licencePlate') + ' *'"
              :placeholder="$t('heavyMachines.licencePlate')"
            />
          </div>
          <div class="col-md-6">
            <div class="col-md-9">
              <image-upload
                :src="imageSrc"
                :show-upload-button="false"
                :select-text="$t('image.selectImage')"
                @change="handleFileUpload"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm d-flex justify-content-end">
            <material-button color="dark" @click="saveMachine">
              {{$t('common.submit')}}
            </material-button>
          </div>
        </div>
      </form>
    </Form>
  </card>
</template>
<script>
import api from "../../services/api"
import { Form } from 'vee-validate';
import ImageUpload from '../../components/ImageUpload.vue';
import Card from "../../components/Card.vue";
import MaterialInputField from "@/components/MaterialInputField.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import { HEAVY_MACHINERY_TOOL_GROUP_TYPE_ID } from './heavyMachineHelper';

export default {
  components: {
    Form,
    ImageUpload,
    Card,
    MaterialInputField,
    MaterialButton
  },
  props: {
    editMode: {
      type: Boolean,
      required: true
    },
    nameProp: {
      type: String,
      required: false,
      default: ''
    },
    licencePlateProp: {
      type: String,
      required: false,
      default: ''
    },
    toolGroupImageBytesProp: {
      type: String,
      required: false,
      default: ''
    },
    machineIdProp: {
      type: String,
      required: false,
      default: ''
    }
  },
  emits: ['close', 'saved'],
  data() {
    return {
      name: this.nameProp,
      licencePlate: this.licencePlateProp,
      toolGroupImageBytes: this.toolGroupImageBytesProp,
      machineId: this.machineIdProp
    };
  },
  computed: {
    computedTitle() {
      return this.editMode ? this.$t('heavyMachines.editHeavyMachine') : this.$t('heavyMachines.createHeavyMachine');
    },
    imageSrc() {
      return this.toolGroupImageBytes ? 'data:image/png;base64,' + this.toolGroupImageBytes : '';
    }
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    async saveMachine() {
      if (this.validateInput()) {
        let requestBody = {
          toolgrouptypeid: HEAVY_MACHINERY_TOOL_GROUP_TYPE_ID,
          name: this.name,
          properties: [{key:'licencePlate', value: this.licencePlate}]
        };
        if(this.toolGroupImageBytes !== '')
        {
          requestBody.toolGroupImageBytes = this.toolGroupImageBytes;
        }

        if (this.editMode) {
          this.editMachine(requestBody);
        }
        else {
          this.createMachine(requestBody);
        }
      }
    },
    async createMachine(requestBody) {
      await api.post('/ToolGroup', requestBody)
        .then(response =>
        {
          this.$toast.success(this.name + " " + this.$t('common.created'), { timeout: 1500 });
          this.$router.push({ name: 'Heavy Machine', params: { toolGroupId: response.data.id.toString() } });
        }).catch(error =>
        {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.error(this.$t('common.unableToCreate'), { timeout: 0 });
        });
    },
    async editMachine(requestBody) {
      await api.put(`/ToolGroup/${this.machineId}`, requestBody)
        .then(response =>
        {
          this.$toast.success(`${this.name} ${this.$t('common.edit')}`, { timeout: 1500 });
          // The push is a no-op when editing from the machine page itself, which reloads on 'saved'
          this.$emit('saved');
          this.$router.push({ name: 'Heavy Machine', params: { toolGroupId: response.data.id.toString() } });
        }).catch(error =>
        {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.error(this.$t('common.unableToUpdate'), { timeout: 0 });
        });
    },
    handleFileUpload(file) {
      if(file){
        const reader = new FileReader();

        reader.onloadend = () => {
          let binary = '';
          const bytes = new Uint8Array(reader.result);
          bytes.forEach((byte) => binary += String.fromCharCode(byte));
          this.toolGroupImageBytes = btoa(binary);
        };
        reader.readAsArrayBuffer(file);
      }
      else{
        this.toolGroupImageBytes = ''
      }
    },
    validateInput() {
      let success = true;
        if (this.name === '') {
          this.$toast.info(this.$t('errors.nameEmpty'), { timeout: 2500 });
          success = false;
        }
        else if (this.licencePlate === '') {
          this.$toast.info(this.$t('errors.licencePlateEmpty'), { timeout: 2500 });
          success = false;
        }
        else if (this.toolGroupImageBytes === '') {
          this.$toast.info(this.$t('errors.imageEmpty'), { timeout: 2500 });
          success = false;
        }
        return success;
    }
  }
};
</script>
<style></style>
